import { render } from "./TestsList.vue?vue&type=template&id=208eb05c&scoped=true"
import script from "./TestsList.vue?vue&type=script&lang=js"
export * from "./TestsList.vue?vue&type=script&lang=js"

import "./TestsList.vue?vue&type=style&index=0&id=208eb05c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-208eb05c"]])

export default __exports__